// https://guides.criteotilt.com/onetag/onetag/?accountid=88562&advertisername=Componata+DE&subdomain=&domain=&homepageurl=http%3A%2F%2Fwww.componata.de%2F&accuratekey=componatade%3B7895156%3B7895157%3B88562

export var TrackingMixin = {
  methods: {
    criteoTracking (data) {
      window.criteo_q = window.criteo_q || [];
      var deviceType = /iPad/.test(navigator.userAgent) ? 't' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'm' : 'd';
      window.criteo_q.push(
        { event: 'setAccount', account: process.env.VUE_APP_CRIT_ACCOUNT },
        { event: 'setEmail', email: '', hash_method: 'none' },
        { event: 'setSiteType', type: deviceType },
        { event: 'setZipcode', zipcode: '' },
        { ...data }
      );
    },
  }
};
